import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "donation-form-subheading" }
const _hoisted_2 = { id: "donation-form-tagline" }
const _hoisted_3 = { class: "repel" }

import { computed, onBeforeMount, toRef } from 'vue';
import AddressFields from '@src/components/pages/donation_form/PersonalData/AddressFields.vue';
import AutofillHandler from '@src/components/shared/AutofillHandler.vue';
import EmailField from '@src/components/shared/form_fields/EmailField.vue';
import MailingListField from '@src/components/shared/form_fields/MailingListField.vue';
import NameFields from '@src/components/pages/donation_form/PersonalData/NameFields.vue';
import type { AddressValidation } from '@src/view_models/Validation';
import type { CampaignValues } from '@src/view_models/CampaignValues';
import type { Country } from '@src/view_models/Country';
import type { Salutation } from '@src/view_models/Salutation';
import type { TrackingData } from '@src/view_models/TrackingData';
import { useAddressFunctions } from '@src/components/pages/donation_form/composables/useAddressFunctions';
import { useAddressTypeFromReceiptSetter } from '@src/components/pages/donation_form/composables/useAddressTypeFromReceiptSetter';
import { useMailingListModel } from '@src/components/shared/form_fields/useMailingListModel';
import type { ReceiptModel } from '@src/components/pages/donation_form/composables/useReceiptModel';
import { useStore } from 'vuex';
import { AddressTypeModel } from '@src/view_models/AddressTypeModel';
import ContentCard from '@src/components/patterns/ContentCard.vue';
import CheckboxToggle from '@src/components/shared/form_elements/CheckboxToggle.vue';

interface Props {
	countries: Country[];
	salutations: Salutation[];
	trackingData: TrackingData;
	campaignValues: CampaignValues;
	addressValidationPatterns: AddressValidation;
	isDirectDebitPayment: boolean;
	disabledAddressTypes: AddressTypeModel[];
	addressType: AddressTypeModel;
	receiptModel: ReceiptModel;
	addressTypeIsInvalid: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PersonalDataSection',
  props: {
    countries: {},
    salutations: {},
    trackingData: {},
    campaignValues: {},
    addressValidationPatterns: {},
    isDirectDebitPayment: { type: Boolean },
    disabledAddressTypes: {},
    addressType: {},
    receiptModel: {},
    addressTypeIsInvalid: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;
const store = useStore();

const mailingList = useMailingListModel( store );
const receiptModel = toRef<ReceiptModel>( props.receiptModel );

const {
	formData,
	fieldErrors,
	initializeDataFromStore,
	onFieldChange,
	onAutofill,
} = useAddressFunctions( { addressValidationPatterns: props.addressValidationPatterns }, store );

useAddressTypeFromReceiptSetter( props.receiptModel.receiptNeeded, computed<AddressTypeModel>( () => props.addressType ), store );

onBeforeMount( initializeDataFromStore );


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ContentCard, { "aria-labelledby": "donation-form-subheading donation-form-tagline" }, {
      heading: _withCtx(() => [
        _createElementVNode("h2", _hoisted_1, "2. " + _toDisplayString(_ctx.$t( 'compact_donation_form_name_heading' )), 1)
      ]),
      content: _withCtx(() => [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t( 'compact_donation_form_name_blurb' )), 1),
        _createElementVNode("form", {
          class: "compact",
          id: "donation-form",
          action: "/donation/add",
          method: "post",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createVNode(AutofillHandler, { onAutofill: _unref(onAutofill) }, {
            default: _withCtx(() => [
              _createVNode(NameFields, {
                "show-error": _unref(fieldErrors),
                "form-data": _unref(formData),
                salutations: __props.salutations,
                onFieldChanged: _unref(onFieldChange)
              }, null, 8, ["show-error", "form-data", "salutations", "onFieldChanged"]),
              _createVNode(EmailField, {
                "show-error": _unref(fieldErrors).email,
                modelValue: _unref(formData).email.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).email.value) = $event)),
                onFieldChanged: _unref(onFieldChange)
              }, null, 8, ["show-error", "modelValue", "onFieldChanged"]),
              _createVNode(MailingListField, {
                modelValue: _unref(mailingList),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(mailingList) ? (mailingList).value = $event : null)),
                "input-id": "newsletter"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["onAutofill"])
        ], 32)
      ]),
      _: 1
    }),
    _createVNode(ContentCard, { "aria-labelledby": "donation-form-subheading donation-form-tagline" }, {
      heading: _withCtx(() => [
        _createElementVNode("h2", null, "3. " + _toDisplayString(_ctx.$t( 'compact_donation_form_other_info_heading' )), 1)
      ]),
      content: _withCtx(() => [
        _createElementVNode("form", {
          class: "flow compact",
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t( 'compact_donation_form_other_info_blurb' )), 1),
            _createVNode(CheckboxToggle, {
              modelValue: receiptModel.value.receiptNeeded,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((receiptModel.value.receiptNeeded) = $event)),
              name: "donation-receipt",
              "input-id": "donation-receipt"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t( 'donation_confirmation_cta_title_alt' )), 1)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          (receiptModel.value.receiptNeeded)
            ? (_openBlock(), _createBlock(AddressFields, {
                key: 0,
                "show-error": _unref(fieldErrors),
                "form-data": _unref(formData),
                countries: __props.countries,
                "post-code-validation": __props.addressValidationPatterns.postcode,
                onFieldChanged: _unref(onFieldChange)
              }, null, 8, ["show-error", "form-data", "countries", "post-code-validation", "onFieldChanged"]))
            : _createCommentVNode("", true)
        ], 32)
      ]),
      _: 1
    })
  ], 64))
}
}

})